(() => {
  const bundleRoots = () => Array.from(document.querySelectorAll('[data-ca-bundle-for]'));
  const updateChoice = (root) => {
    const selected = root.querySelector('input[type="radio"]:checked');
    root.querySelectorAll('[data-ca-choice]').forEach((choice) => choice.classList.toggle('is-selected', choice.contains(selected)));
  };
  const getRootForForm = (form) => bundleRoots().find((root) => root.dataset.caBundleFor === form.id) || (bundleRoots().length === 1 ? bundleRoots()[0] : null);
  const formFromEvent = (event) => {
    const path = event.composedPath ? event.composedPath() : [];
    return path.find((node) => node instanceof HTMLFormElement) || (event.target instanceof HTMLFormElement ? event.target : event.target.closest?.('form'));
  };
  const submitButtonFromEvent = (event) => {
    const path = event.composedPath ? event.composedPath() : [];
    return path.find((node) => node instanceof HTMLElement && node.matches('button[type="submit"], input[type="submit"]')) || event.target.closest?.('button[type="submit"], input[type="submit"]');
  };
  const getCurrentVariantId = (form, root) => {
    const idInput = form.querySelector('[name="id"]');
    const picker = document.querySelector('variant-picker[form-id="' + CSS.escape(form.id) + '"]');
    const json = picker?.querySelector('script[data-variant]');
    if (json) {
      try {
        const variant = JSON.parse(json.textContent);
        if (variant?.id) return Number(variant.id);
      } catch (_) {}
    }
    return Number(idInput?.value);
  };
  const syncFirstSize = (form, root) => {
    const variantId = getCurrentVariantId(form, root);
    const second = root.querySelector('[data-ca-second-variant]');
    const first = root.querySelector('[data-ca-first-size]');
    const option = second && Array.from(second.options).find((item) => Number(item.value) === variantId);
    if (first && option) first.textContent = option.textContent;
    if (second && !root.dataset.caSecondTouched && option) second.value = option.value;
  };
  const addBundle = async (form, root) => {
    if (root.dataset.caBusy === 'true') return;
    root.dataset.caBusy = 'true';
    const firstVariant = getCurrentVariantId(form, root);
    const secondVariant = Number(root.querySelector('[data-ca-second-variant]')?.value || firstVariant);
    const button = form.querySelector('[type="submit"]');
    const error = root.querySelector('[data-ca-error]');
    if (!firstVariant || !secondVariant) {
      root.dataset.caBusy = 'false';
      if (error) { error.textContent = 'Selecteer beide maten voordat je verdergaat.'; error.hidden = false; }
      return;
    }
    if (button) button.disabled = true;
    if (error) { error.textContent = ''; error.hidden = true; }

    const rootPath = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: firstVariant, quantity: 1 }, { id: secondVariant, quantity: 1 }] })
      });
      if (!response.ok) {
        const details = await response.json().catch(() => ({}));
        throw new Error(details.description || 'De aanbieding kon niet worden toegevoegd.');
      }
      window.location.assign(rootPath + 'cart');
    } catch (err) {
      root.dataset.caBusy = 'false';
      if (error) { error.textContent = err.message || 'De aanbieding kon niet worden toegevoegd. Probeer het opnieuw.'; error.hidden = false; }
      if (button) button.disabled = false;
    }
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    const root = target.closest?.('[data-ca-bundle-for]');
    if (root && target.matches('input[type="radio"]')) updateChoice(root);
    const form = target.closest?.('form[id]');
    if (form) {
      const matchingRoot = getRootForForm(form);
      if (matchingRoot) queueMicrotask(() => syncFirstSize(form, matchingRoot));
    }
    if (root && target.matches('[data-ca-second-variant]')) root.dataset.caSecondTouched = 'true';
  });

  const interceptBundle = (event, form) => {
    const root = form && getRootForForm(form);
    if (!root) return false;
    const selected = root.querySelector('input[type="radio"]:checked');
    if (!selected || selected.value !== 'bundle') return false;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addBundle(form, root);
    return true;
  };

  document.addEventListener('click', (event) => {
    const submitButton = submitButtonFromEvent(event);
    if (!submitButton) return;
    const form = submitButton.form || formFromEvent(event);
    interceptBundle(event, form);
  }, true);

  document.addEventListener('submit', (event) => {
    interceptBundle(event, formFromEvent(event));
  }, true);

  bundleRoots().forEach((root) => {
    updateChoice(root);
    const form = document.getElementById(root.dataset.caBundleFor);
    if (form) syncFirstSize(form, root);
  });
})();
